export const inHousePackageQueryKey = {
  all: ['in-house-packages'] as const,
  packages: () => [...inHousePackageQueryKey.all, 'list'] as const,
  options: () => [...inHousePackageQueryKey.all, 'options'] as const,
  patterns: (packageId: string) => [...inHousePackageQueryKey.all, 'patterns', packageId] as const,
  applicationInstances: (patternId: string, options?: {
    page?: number;
    pageSize?: number;
    targetId?: string;
  }) => [...inHousePackageQueryKey.all, 'application-instances', patternId, options?.page ?? 1, options?.pageSize ?? 100, options?.targetId] as const,
  // ページング引数は optional な階層に分ける。options 省略で patternId までの
  // prefix になり、`invalidateQueries` でパターン単位（全ページ）を無効化できる。
  instanceTagSummaries: (patternId: string, options?: {
    page?: number;
    pageSize?: number;
  }) => [...inHousePackageQueryKey.all, 'instance-tag-summaries', patternId, ...(options ? [options.page ?? 1, options.pageSize ?? 50] : [])] as const,
  taskCountInProgress: (packageId: string, patternId: string) => [...inHousePackageQueryKey.all, 'task-count-in-progress', packageId, patternId] as const,
  confirmationRows: (patternId: string, options?: {
    page?: number;
    pageSize?: number;
    targetId?: string;
    tagId?: string;
  }) => [...inHousePackageQueryKey.all, 'confirmation-rows', patternId, options?.page ?? 1, options?.pageSize ?? 100, options?.targetId, options?.tagId] as const
} as const;